        <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
      <ng-template #start>
        <button
          pButton
          type="button"
          icon="pi pi-print"
          label="Print"
          class="p-button-sm p-button-secondary"
          (click)="printCombinePickingList()"
        ></button>
        <!-- <button
          pButton
          type="button"
          icon="pi pi-file-pdf"
          label="Export as PDF"
          class="p-button-sm p-button-secondary ml-2"
          (click)="exportToPDF()"
        ></button> -->
        <div style="display: inline-block; margin-left: 16px;">
          <label for="languageSelect" style="margin-right: 8px;">Language:</label>
          <select id="languageSelect" [(ngModel)]="selectedLanguage">
            <option value="en">English</option>
            <option value="de">German</option>
            <option value="nl">Dutch</option>
          </select>
        </div>
      </ng-template>
      <ng-template #end>
        <button
          pButton
          type="button"
          icon="pi pi-arrow-left"
          label="Back"
          class="p-button-sm p-button-secondary ml-2"
          (click)="goBack()"
        ></button>
      </ng-template>
    </p-toolbar>
  </div>
  
  

  <div #combinePickingList>
    <div *ngFor="let pageLines of paginatedCombineContent; let i = index">
      <div class="invoice-wrapper">
        <div class="header-top">
          <img
            *ngIf="div1 === '400'; else deHeader"
            src="assets/Header.jpg"
            alt="Sidhu Food B.V. Logo"
            class="logo"
          />
          <ng-template #deHeader>
            <img
              src="assets/header_DE.jpg"
              alt="Sidhu Food B.V. Logo DE"
              class="logo"
            />
          </ng-template>
        </div>
        <div class="main-content">
          <!-- Big Bold Heading -->
          <div style="text-align:right; margin-bottom: 1px;">
            <span style="font-size: 2rem; font-weight: bold;">
              {{ getLabel('combinedPickingListTitle') }} - 
              {{
                combinePickingListInfo.pickingListType === 'frozone'
                  ? (selectedLanguage === 'de' ? 'Gefroren' : selectedLanguage === 'nl' ? 'Diepvries' : 'Frozen')
                  : combinePickingListInfo.pickingListType === 'nonfrozone'
                    ? (selectedLanguage === 'de' ? 'Nicht gefroren' : selectedLanguage === 'nl' ? 'Niet diepvries' : 'Non Frozen')
                    : combinePickingListInfo.pickingListType
              }}
            </span>
          </div>
          <!-- Row for From, To, Status -->
          <div style="display: flex; justify-content: flex-end; gap: 32px; margin-bottom: 20px;">
            <div>
              <span style="font-weight: bold; font-size: 1.1rem;">{{ getLabel('from') }}:</span>
              <span style="font-size: 1.1rem;">{{ combinePickingListInfo.fromDate }}</span>
            </div>
            <div>
              <span style="font-weight: bold; font-size: 1.1rem;">{{ getLabel('to') }}:</span>
              <span style="font-size: 1.1rem;">{{ combinePickingListInfo.toDate }}</span>
            </div>
            <div>
              <span style="font-weight: bold; font-size: 1.1rem;">{{ getLabel('status') }}:</span>
              <span style="font-size: 1.1rem;">{{ combinePickingListInfo.status }}</span>
            </div>
          </div>

          <table class="items-table">
            <thead>
              <tr>
                <th>{{ getLabel('lineNo') }}</th>
                <th>{{ getLabel('itemNo') }}</th>
                <th>{{ getLabel('quantity') }}</th>
                <th>{{ getLabel('itemName') }}</th>
                <th>{{ getLabel('pcs') }}</th>
                <th>{{ getLabel('size') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of pageLines">
                <td>{{ line.lineNo }}</td>
                <td>{{ line.itemNo }}</td>
                <td>{{ line.totalQty }}</td>
                <td>{{ line.description }}</td>
                <td>{{ line.pcs }}</td>
                <td>{{ line.size }}</td>
              </tr>
            </tbody>
          </table>

          <ng-container *ngIf="i === paginatedCombineContent.length - 1">
            <div class="total-row left-align">
              <table class="invoice-summary" style="margin-top: 20px">
                <tr>
                  <td><strong>{{ getLabel('totalPackedQty') }}</strong></td>
                  <td style="text-align: right; font-weight: normal;">{{ combineSummary.packedQty }}</td>
                </tr>
                <tr>
                  <td><strong>{{ getLabel('totalGrossWeight') }}</strong></td>
                  <td style="text-align: right; font-weight: normal;">
                    {{ combineSummary.totalGrossWeight | number:'1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td><strong>{{ getLabel('totalNetWeight') }}</strong></td>
                  <td style="text-align: right; font-weight: normal;">
                    {{ combineSummary.totalNetWeight | number:'1.2-2' }}
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
        </div>
           <div class="watermark-footer">
  <img src="assets/torna_logo.png" alt="Watermark" />
</div>
        <div class="footer">
          <img
            *ngIf="div1 === '400'; else deFooter"
            src="assets/Footer.jpg"
            alt="Sidhu Food B.V. Footer"
            class="footer-logo"
          />
          <ng-template #deFooter>
            <img
              src="assets/footer_DE.jpg"
              alt="Sidhu Food B.V. Footer DE"
              class="footer-logo"
            />
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <!-- Add your UI here -->

